import moment from "moment";

export const formatDate = (date: string) => {
   if(date){
      return new Date(date)
   }else{
    return null
   }
};
